var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IdenticonActions, IdenticonAuth0LogoLight, IdenticonAuthenticationA, IdenticonBranding, IdenticonCustomization, IdenticonDatabase, IdenticonExtensions, IdenticonGettingStarted, IdenticonHelp, IdenticonLogin, IdenticonMonitoring, IdenticonSecurity, IdenticonSocialProviders, IdenticonUserManagement, } from '@a0/quantum-product';
import * as React from 'react';
export var Identicon = function (_a) {
    var name = _a.name, props = __rest(_a, ["name"]);
    var IconComponent;
    switch (name) {
        case 'IdenticonAuth0LogoLight':
            IconComponent = IdenticonAuth0LogoLight;
            break;
        case 'IdenticonGettingStarted':
            IconComponent = IdenticonGettingStarted;
            break;
        case 'IdenticonAuthenticationA':
            IconComponent = IdenticonAuthenticationA;
            break;
        case 'IdenticonUserManagement':
            IconComponent = IdenticonUserManagement;
            break;
        case 'IdenticonCustomize':
            IconComponent = IdenticonCustomization;
            break;
        case 'IdenticonSecurity':
            IconComponent = IdenticonSecurity;
            break;
        case 'IdenticonMonitoring':
            IconComponent = IdenticonMonitoring;
            break;
        case 'IdenticonTroubleshoot':
            IconComponent = IdenticonHelp;
            break;
        case 'IdenticonDatabase':
            IconComponent = IdenticonDatabase;
            break;
        case 'IdenticonSocialProviders':
            IconComponent = IdenticonSocialProviders;
            break;
        case 'IdenticonLogin':
            IconComponent = IdenticonLogin;
            break;
        case 'IdenticonBranding':
            IconComponent = IdenticonBranding;
            break;
        case 'IdenticonActions':
            IconComponent = IdenticonActions;
            break;
        case 'IdenticonExtensions':
            IconComponent = IdenticonExtensions;
            break;
        default:
            break;
    }
    if (!IconComponent) {
        throw new Error("No icon found with the name \"".concat(name, "\""));
    }
    return React.createElement(IconComponent, __assign({}, props));
};
